import Vue from 'vue';
import { kFormatter, replaceToOriginStr } from '@/utils/tools';
import { get_keywords } from '@/utils/seo_file';

Vue.filter('kFormatter', kFormatter);

export default ({ app }) => {
  setTdkDynamic(app);
  if (process.server) {
    app.store.commit('app/setServerEnv', {
      CURRENT_VERSION: process.env.CURRENT_VERSION,
      CURRENT_ENV: process.env.CURRENT_ENV,
      MODE_ENV: process.env.MODE_ENV,
      type: 'server',
    });
  }
  if (process.client) {
    app.store.commit('app/setClientEnv', {
      CURRENT_CLIENT_VERSION: process.env.CURRENT_CLIENT_VERSION,
      CURRENT_CLIENT_ENV: process.env.CURRENT_CLIENT_ENV,
      MODE_ENV: process.env.MODE_CLIENT_ENV,
      type: 'client',
    });
  }
};

function setTdkDynamic(app) {
  const originalUrl = app.context?.req?.originalUrl;
  if (!originalUrl) return;

  const pathname = `${app.context?.req?._parsedUrl.pathname}${app.context?.req?._parsedUrl.query}`;
  
  const tdkCache = app.context?.req?.tdkCache?.get(pathname);
  if (tdkCache) {
    setTdk(app, {
      title: tdkCache.title,
      description: tdkCache.desc,
      keywords: tdkCache.keywords,
    });
  } else {
    setTdk(app, get_keywords(originalUrl));
  }
}

function setTdk(app, key_words) {
  app.head.title = replaceToOriginStr(key_words.title || '');
  app.head.meta.push({
    name: 'description',
    content: key_words.description,
  });
  app.head.meta.push({
    name: 'keywords',
    content: key_words.keywords,
  });
}
